
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AllFreelancersResponse,
} from '../models';
import {
    AllFreelancersResponseFromJSON,
    AllFreelancersResponseToJSON,
} from '../models';

export interface SearchAllFreelancersRequest {
    p?: number;
    size?: number;
    locale?: string;
}

/**
 * 
 */
export class AllFreelancersSearchApi extends runtime.BaseAPI {

    /**
     * Search all visible profiles
          */
    async searchAllFreelancersRaw(requestParameters: SearchAllFreelancersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AllFreelancersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AllFreelancersResponse>({
            path: `/cms/api/search/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AllFreelancersResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search all visible profiles
          */
    async searchAllFreelancers(requestParameters: SearchAllFreelancersRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AllFreelancersResponse> {
        const response = await this.searchAllFreelancersRaw(requestParameters, initOverrides);
        return response._data;
    }

}
